<template src="./assetchecks.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  var moment = require("moment");
  export default {
    props: ["NewAsset", "type"],

    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    data() {
      return {
        ImageEndpoint: Endpoints.Helper.Image + "/",
        AssetChecks: [],
        fromDate: "",
        toDate: "",
        name: "",
        SearchData: false,
        ShowAssetNotesModel: false,
        AssetNotes: "",
        ShowAssetNotesModelHeading: "Notes",
        ShowFailedCheckModel: false,
        FailedChecks: [],
        SafeNotes: "",
        date_fixed: "",
        PopupLoader: false,
        SubmitFailedChecksNotes: {},    
      };
    },
    mounted() {
      setTimeout(() => {
        this.GetAssetChecksList();
      }, 3000);
    },
    methods: {
      GetAssetChecksList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.name;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
        }
        this.SearchData = true;
        obj.assetId = this.NewAsset.id;
        obj.requestFor = this.type;
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Checks.List, obj).then(
          (Response) => {
            this.ShowLoader = false;
            this.SearchData = false;
            if (Response.data.success) {
              this.AssetChecks = Response.data.FleetCheckSubmit;
            }
          }
        );
      },
      ShowAssetNotes(AssetCheck, type = "notes") {
        if (AssetCheck.notes != null && AssetCheck.notes != "") {
          this.ShowAssetNotesModel = true;
          this.AssetNotes = AssetCheck.notes;
          this.ShowAssetNotesModelHeading = "Notes";
        }
      },
      MarkSafe() {
        this.ShowFailedCheckModel = true;
        var obj = { token: localStorage.getItem("token") };
        obj.assetId = this.NewAsset.id;
        this.ShowLoader = true;
        console.log(Endpoints.Assets.Checks.GetAssetFailedCheckAssets)
        Axios.post(Endpoints.Assets.Checks.GetAssetFailedCheckAssets, obj).then((Response) => {
            this.ShowLoader = false;
            if (Response.data.success) {
                this.FailedChecks = Response.data.FailedChecks;
            }
        });
      },
      MarkSafeSubmit(){        
        if(this.SafeNotes == "") {
            this.$swal("Following Error Found!", "Please Enter Notes", "error").then(() => {});
        }else if(this.date_fixed == "") {
            this.$swal("Following Error Found!", "Please Enter Date Fixed", "error").then(() => {});
        }else{            
            var obj = { token: localStorage.getItem("token") };
            obj.assetId = this.NewAsset.id;
            obj.date_fixed = this.date_fixed;
            obj.notes = this.SafeNotes;
            obj.SubmitFailedChecksNotes = this.SubmitFailedChecksNotes;
            obj.FailedChecks = this.FailedChecks;            
            this.PopupLoader = true;
            Axios.post(Endpoints.Assets.Checks.marksafeAsset, obj).then((Response) => {
                this.PopupLoader = false;
                if (Response.data.success) {                   
                    this.ShowFailedCheckModel = false;
                    this.$swal("Asset Check Marked Safe Successfully", "", "success").then(() => {
                        window.location.reload();
                    });                    
                }
            })
        }
      },
    }        
  };
</script>
<style scoped>
  .asset-check-div {
    height: 177px;
    overflow-y: scroll;
    padding-right: 17px;
  }
</style>
